import axios from 'axios';

import { authHeader } from '@H';
import { authService } from '@S';

const createBunkConfigFormData = (configuration, uuid) => {
  const formData = new FormData();

  if (uuid) {
    formData.append('uuid', uuid);
  }

  if (authService.currentAccountID) {
    formData.append('bunk_id', authService.currentAccountID);
  }

  // Swagger marks `configuration` as an object in form-data, so we send it as JSON.
  formData.append('configuration', JSON.stringify(configuration));

  return formData;
};

const getMultipartHeaders = () => {
  const headers = authHeader(1);
  const { ['Content-Type']: _contentType, ...rest } = headers;
  return rest;
};

export default {
  getNavigationData: () =>
    axios({
      method: 'GET',
      headers: authHeader(1),
      url: `${process.env.API_URL}/utils/navigation_bar/`,
    }),
  getBanners: () =>
    axios({
      method: 'GET',
      headers: authHeader(1),
      url: `${process.env.API_URL}/bunk/bunk_banner/`,
    }),

  getBunkConfig: () =>
    axios({
      method: 'GET',
      headers: authHeader(1),
      url: `${process.env.API_URL}/bunk/bunk_configuration/`,
    }),

  postBunkConfig: (configuration) =>
    axios({
      method: 'POST',
      headers: getMultipartHeaders(),
      url: `${process.env.API_URL}/bunk/bunk_configuration/`,
      data: createBunkConfigFormData(configuration),
    }),

  putBunkConfig: (uuid, configuration) =>
    axios({
      method: 'PUT',
      headers: getMultipartHeaders(),
      url: `${process.env.API_URL}/bunk/bunk_configuration/`,
      data: createBunkConfigFormData(configuration, uuid),
    }),

  deleteBunkConfig: (uuid) =>
    axios({
      method: 'DELETE',
      headers: authHeader(1),
      url: `${process.env.API_URL}/bunk/bunk_configuration/`,
    }),
};
